import { intramurosBase } from '@/utils/intramuros'

import type { QuestionnaireTask, Task } from '@/modules/task/types/task.types'

/**
 * Returns the task type for analytics, distinguishing reconfirmation questionnaires.
 */
export function getAnalyticsTaskType(task: Task): string {
  if (task.type === 'Questionnaire' && 'reconfirmation' in task && task.reconfirmation) {
    return 'QuestionnaireReconfirmation'
  }
  return task.type
}

/**
 * Get the URL to the questionnaire flow for a questionnaire task
 *
 * @param task - The questionnaire task
 * @returns The URL for the questionnaire task
 */
export function buildQuestionnaireTaskUrl(task: QuestionnaireTask, awellHostedPagesEnabled?: boolean) {
  const questionnaireIdOrSlug = task.questionnaireId || task.questionnaireSlug

  const shouldUseAwellHostedPages = awellHostedPagesEnabled && task.driver === 'awell'

  const activityId = task.careplanActivityId

  const search = new URLSearchParams({
    view: shouldUseAwellHostedPages ? 'awell' : 'default',
  })

  if (!questionnaireIdOrSlug) {
    console.error('No questionnaire ID or slug found')
    return
  }

  if (intramurosBase) {
    return `${intramurosBase}/questionnaire/${activityId}?${search}`
  }

  return `/questionnaire/${activityId}?${search}`
}

/**
 * Get the URL to the questionnaire edit flow for a questionnaire task
 * @param task - The questionnaire task
 * @param linkId - The link ID of the answer to edit
 * @returns The URL for the questionnaire edit task
 * @param linkId
 */
export function buildQuestionnaireTaskEditUrl(task: QuestionnaireTask, linkId: string) {
  const activityId = task.careplanActivityId
  const flowPath = task.prefill ? 'prefill' : 'reconfirm'

  return `/questionnaire/${activityId}/${flowPath}?linkId=${linkId}`
}
